const shopImages = import.meta.glob('../imgs/Shops/*.(png|jpg|jpeg|svg|webp)', { eager: true }) as Record<string, { default: string }>

// Create a mapping of brand names to their image URLs
const brandLogoMap: Record<string, string> = {}

// Process the imported images
Object.entries(shopImages).forEach(([path, module]) => {
  // Extract the filename without extension from the path
  const filename = path!
    .split('/')!
    .pop()!
    .replace(/\.(png|jpg|jpeg|svg|webp)$/, '')
  brandLogoMap[filename] = module!.default
})

export const getBrandLogo = (brand: string) => {
  // Try to find the exact brand match
  if (brandLogoMap[brand]) {
    return brandLogoMap[brand]
  }

  const extensions = ['png', 'jpg', 'jpeg', 'svg', 'webp']
  for (const ext of extensions) {
    const key = `${brand}.${ext}`
    if (brandLogoMap[key]) {
      return brandLogoMap[key]
    }
  }

  // Fallback to Other.png
  return brandLogoMap['Other'] || brandLogoMap['Other.png']
}
